import { Suspense, useEffect, useState } from 'react'
import clsx from 'clsx'
import SkeletonLoading from '../common/SkeletonLoading'
import { v4 } from 'uuid'
import { isValidStr, strToSlug } from '../../common_functions'
import { IconTitle } from '../../interfaces/enterprise/enterpriseIconTitle'

interface EnterpriseDetailCard {
  IconsTextList: IconTitle[] | null | undefined
  idHTML: string
  isOrangeSelect?: boolean
  hrMargin?: boolean
  changeSelectedItem?: (item: IconTitle) => void
}

export default function IconsTextBox({
  IconsTextList,
  isOrangeSelect = false,
  idHTML,
  hrMargin = false,
  changeSelectedItem
}: EnterpriseDetailCard) {
  const [selectedItems, setSelectedItems] = useState<IconTitle[]>([])
  const [searchInput, setSearchInput] = useState('')
  const [showBtnSee, setShowBtnSee] = useState(true)
  const [filterItems, setFilterItems] = useState<IconTitle[] | null | undefined>(
    IconsTextList?.slice(0, 10)
  )
  const [isFullItems, setIsFullItems] = useState(false)

  const handleChangeSelectedItem = (item: IconTitle) => {
    if (selectedItems?.includes(item)) {
      setSelectedItems(selectedItems.filter((x) => x != item))
    } else {
      setSelectedItems((prev) => [...prev, item])
    }
    if (changeSelectedItem != undefined) changeSelectedItem(item)
  }

  const handleChangeFilterItems = () => {
    if (isFullItems) {
      setFilterItems(IconsTextList?.slice(0, 10))
    } else {
      setFilterItems(IconsTextList)
    }
    setIsFullItems(!isFullItems)
  }

  useEffect(() => {
    setFilterItems(IconsTextList?.slice(0, 10))
    setIsFullItems(false)
  }, [IconsTextList])

  const handleFilterItems = (val:string) => {
    setSearchInput(val)
    if(searchInput && searchInput.length > 1){
      setShowBtnSee(false)
      setFilterItems(IconsTextList?.filter(x => x.Title.toLowerCase().includes(searchInput)))
    }else{
      setShowBtnSee(true)
      setFilterItems(IconsTextList?.slice(0, 10))
    }
  }

  return (
    <>
      {IconsTextList != undefined && IconsTextList.length > 0 ? (
        <>
          <section className="p-3 pl-0" id={idHTML}>
            {/* CONTENT */}
            <div className={clsx('grid grid-cols-3 lg:grid-cols-5 gap-1 lg:gap-2 flex-wrap')}>
              <>
                {filterItems?.map((dif) => {
                  return (
                    <button disabled={true} onClick={() => handleChangeSelectedItem(dif)}>
                      <div
                        key={`${strToSlug(dif.Title ?? v4())}`}
                        className={
                          'bg-[#F4F6F9] border content-center h-full border-gray-200 rounded-[4px] lg:rounded-[14px] p-2 '
                        }
                      >
                        <div className="grid">
                          <div className="min-w-[32px]">
                            <Suspense fallback={<SkeletonLoading />}>
                              <img
                                alt="Icone de Diferenciais"
                                src={dif.Icon}
                                className="w-[32px] h-[32px] m-auto filter-brightness-none"
                              />
                            </Suspense>
                          </div>
                          <div className="text-center m-auto mt-2">
                            <h5
                              className={`text-sm fw-normal`}
                            >
                              {dif.Title}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </button>
                  )
                })}
              </>
            </div>
          </section>
          {hrMargin && <hr className={`mt-4 z-[-1] relative opacity-[0.1]`} />}
        </>
      ) : (
        <></>
      )}
    </>
  )
}
